/** 管理端统一北京时间（Asia/Shanghai）格式化，不随浏览器本地时区变化 */

const BJ_TZ = 'Asia/Shanghai'

export const EMPTY = '—'

function parseInput(val) {
  if (val == null || val === '') return null
  if (val instanceof Date) {
    return Number.isFinite(val.getTime()) ? val : null
  }
  if (typeof val === 'number' && Number.isFinite(val)) {
    const d = new Date(val)
    return Number.isFinite(d.getTime()) ? d : null
  }
  const s = String(val).trim()
  if (!s || s === 'Invalid Date') return null
  // 纯日期按北京时间中午解析，避免 UTC 日界偏移
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const d = new Date(`${s}T12:00:00+08:00`)
    return Number.isFinite(d.getTime()) ? d : null
  }
  const d = new Date(s)
  return Number.isFinite(d.getTime()) ? d : null
}

function bjParts(d) {
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: BJ_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).formatToParts(d)
}

function partValue(parts, type) {
  const p = parts.find((x) => x.type === type)
  return p ? p.value : '00'
}

/**
 * 格式化为北京时间
 * @param {*} val Date / ISO 字符串 / 时间戳
 * @param {string} format YYYY-MM-DD HH:mm:ss | YYYY-MM-DD | HH:mm:ss | YYYY-MM-DD HH:mm
 */
export function formatDateTime(val, format = 'YYYY-MM-DD HH:mm:ss') {
  try {
    const d = parseInput(val)
    if (!d) return EMPTY
    const parts = bjParts(d)
    const Y = partValue(parts, 'year')
    const M = partValue(parts, 'month')
    const D = partValue(parts, 'day')
    const h = partValue(parts, 'hour')
    const m = partValue(parts, 'minute')
    const s = partValue(parts, 'second')
    if (format === 'YYYY-MM-DD') return `${Y}-${M}-${D}`
    if (format === 'HH:mm:ss') return `${h}:${m}:${s}`
    if (format === 'YYYY-MM-DD HH:mm') return `${Y}-${M}-${D} ${h}:${m}`
    return `${Y}-${M}-${D} ${h}:${m}:${s}`
  } catch (_e) {
    return EMPTY
  }
}

/** 仅日期 YYYY-MM-DD */
export function formatDate(val) {
  return formatDateTime(val, 'YYYY-MM-DD')
}

/** 仅时间 HH:mm:ss */
export function formatTime(val) {
  return formatDateTime(val, 'HH:mm:ss')
}

/** 与 formatDateTime 相同，兼容旧引用 */
export function formatBeijingDateTime(val) {
  return formatDateTime(val)
}

/** 当前北京时间日期 YYYY-MM-DD */
export function beijingToday() {
  return formatDate(new Date())
}

/** 当前北京时间日期时间 */
export function beijingNow() {
  return formatDateTime(new Date())
}
